// Position skills — 4–5 position-specific core factors per football position group (school-editable).
import { useEffect, useState } from "react";
import api from "./api";
import { fbBasePos } from "./roster";

export const SKILL_EDIT_ROLES = ["super_admin", "athletic_director", "deputy_ad", "gm", "head_coach"];
export const SKILL_GROUPS = [
  ["QB", "Quarterbacks", ["QB"]], ["RB", "Running backs", ["RB", "FB"]], ["WR", "Wide receivers", ["WR"]], ["TE", "Tight ends", ["TE"]],
  ["OL", "Offensive line", ["OC", "OG", "OT"]], ["DL", "Interior D-line", ["NT", "DT"]], ["EDGE", "Edge / DE", ["DE", "EDGE"]], ["LB", "Linebackers", ["ILB", "OLB"]],
  ["CB", "Corners", ["CB", "NB"]], ["S", "Safeties", ["S"]], ["K", "Kickers / punters", ["K", "P"]], ["LS", "Long snappers", ["LS"]],
];
export const skillGroupOf = (position) => {
  if (!position) return null;
  const b = fbBasePos(position);
  return SKILL_GROUPS.find((g) => g[2].includes(b))?.[0] || null;
};
export const isSkillKey = (k) => String(k).startsWith("ps_");

// Cached per school (super admins can switch school scope).
let resolved = null, pending = null, cachedFor = null;
const subs = new Set();
const scope = () => localStorage.getItem("omni_active_school") || "";
export function loadSkillConfig() {
  if (cachedFor !== scope()) { resolved = null; cachedFor = scope(); }
  if (resolved) return Promise.resolve(resolved);
  pending ||= api.get("/position-skills?sport=Football").then(({ data }) => (resolved = data)).catch(() => ({ groups: {}, error: true })).finally(() => { pending = null; });
  return pending;
}
export const cachedSkillConfig = () => resolved;
export async function saveSkillConfig(groups) {
  const { data } = await api.put("/position-skills", { sport: "Football", groups });
  resolved = data;
  subs.forEach((fn) => fn(data));
  return data;
}
export function useSkillConfig() {
  const [cfg, setCfg] = useState(resolved);
  useEffect(() => {
    let on = true;
    loadSkillConfig().then((c) => on && setCfg(c));
    subs.add(setCfg);
    return () => { on = false; subs.delete(setCfg); };
  }, []);
  return cfg;
}

// Skills for a position from the loaded list ([] until loaded / not a football position).
export const skillsFor = (position, cfg = resolved) => cfg?.groups?.[skillGroupOf(position)] || [];
// Skill keys that count for this recruit: his position's list once loaded, otherwise whatever skills are rated.
export function skillKeys(cf, position) {
  if (resolved && position !== undefined) return skillsFor(position).map((s) => s.key);
  return Object.keys(cf || {}).filter(isSkillKey);
}
export function skillLabel(k) {
  for (const list of Object.values(resolved?.groups || {})) {
    const hit = list.find((s) => s.key === k);
    if (hit) return hit.label;
  }
  const words = String(k).replace(/^ps_[a-z]+_/, "").replace(/_/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}
